import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
const pains = ['¿Pierdes ventas porque respondes 2 horas tarde?', '¿Estás harto de escribir 50 veces al día lo mismo?', '¿Tus clientes se quejan de que "nadie les atiende"?', '¿No puedes cenar sin que el teléfono vibre cada 30 segundos?'];
export function PainPoints() {
  return <section className="py-20 px-4 bg-dark-card border-y border-dark-border" data-id="element-76">
      <div className="max-w-6xl mx-auto" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-78">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-79">
            Dime si te suena conocido:
          </h2>
          <div className="w-24 h-1 bg-red-500 mx-auto rounded-full" data-id="element-80" />
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-81">
          <div className="space-y-6" data-id="element-82">
            {pains.map((pain, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="flex items-start gap-4 bg-dark-lighter p-5 rounded-2xl rounded-tl-none border border-red-500/20 relative" data-id="element-83">
                {/* Chat bubble tail */}
                <div className="absolute top-0 -left-3 w-4 h-4 bg-dark-lighter border-l border-t border-red-500/20 [clip-path:polygon(100%_0,0_0,100%_100%)]" data-id="element-84" />

                <AlertCircle className="w-6 h-6 text-red-500 shrink-0 mt-1" data-id="element-85" />
                <p className="text-lg md:text-xl text-gray-200 font-medium" data-id="element-86">
                  {pain}
                </p>
              </motion.div>)}
          </div>

          <div className="grid grid-cols-2 gap-4" data-id="element-87">
            <motion.img initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} src="https://cdn.magicpatterns.com/uploads/tFr4grqmRhqqpzQWy8UTRC/KIT_RESCUE_1.jpg" alt="Hombre estresado trabajando de noche" className="w-full h-64 object-cover rounded-2xl border border-dark-border grayscale-[0.5] hover:grayscale-0 transition-all duration-500" data-id="element-88" />
            <motion.img initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} src="https://cdn.magicpatterns.com/uploads/2fj8WndpKrPCdiGxbmUhKV/KIT_RESCUE_MUJER_1.2_MUY_BUENA.jpg" alt="Mujer estresada con envíos" className="w-full h-64 object-cover rounded-2xl border border-dark-border grayscale-[0.5] hover:grayscale-0 transition-all duration-500 mt-8" data-id="element-89" />
          </div>
        </div>
      </div>
    </section>;
}